import { HomeSessionsTable } from './HomeSessionsTable';
export default HomeSessionsTable;
